import React from "react";
import ExpeditionInfo from "../components/adventures/ExpeditionInfo";

const Expeditions = () => {
  return (
    <section className="relative w-full min-h-screen text-white overflow-hidden">
       <ExpeditionInfo />
    </section>
  );
};

export default Expeditions;
